// extracted by mini-css-extract-plugin
export default {"widgetCardsWrapper":"ScheduleQualityTrend_widgetCardsWrapper__vmEL+","chart":"ScheduleQualityTrend_chart__zsENG"};